/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import TableRow from "../../Helpers/Table/TableRow";
import TableActions from "../../Helpers/Table/TableActions";
import { filtrationcontext } from "../../../context/Filtercontext";
import Empty from "../../Helpers/Empty/Empty";
import trans from "../../../utils";

export default function NotificationTableBody({ data }) {
	let { searchQuery } = useContext(filtrationcontext);
	let SearchFilteredData = data;
	if (searchQuery) {
		SearchFilteredData = data?.filter((i) =>
			i.type.toLowerCase().includes(searchQuery?.toLowerCase())
		);
	}
	let getAlertType = (type) => {
		if (type === "deviceOverspeed") {
			return "Speed Alert.";
		} else if (type === "geofenceExit") {
			return "Geofence exited.";
		} else if (type === "geofenceEnter") {
			return "Geofence entered.";
		} else if (type === "deviceFuelDrop") {
			return "Fuel Drop";
		} else if (type === "deviceFuelIncrease") {
			return "Fuel Increase";
		}
	};

	if (SearchFilteredData?.length === 0)
		return <Empty title={trans("No notifications found")} />;
	return (
		<>
			{SearchFilteredData?.map((i) => (
				<div key={i.id} className="table-row">
					<TableRow
						value={i.type}
						style="table-element-name ps-0 text-capitalize"
					/>
					{/**<TableRow value={i.notificators} />**/}
					<TableActions notifiyid={i.id} type="display-off" />
				</div>
			))}
		</>
	);
}
